import React from "react";
import { getFileName, toFileList } from "../utils";
// import { BACKEND_API_URL } from "../../config";

export const RenderSlidePreview = ({ slide, data }) => {
    // // console.log(slide, data);
    switch (slide) {
        case "1":  // Manager Details
            return (
                <>
                    {data.firstName + ' | ' 
                        + data.title + ' | ' 
                        + data.email + ' | ' 
                        + data.cellNumber
                    }
                </>
            )

        case "2": // Employee Details
            return (
                <>
                    {data?.data?.map((employee, index) => 
                        <div key={index}>
                            {index+1 + ". " + employee.firstName + ' | ' 
                                + employee.title + ' | ' 
                                + employee.email + ' | ' 
                                + employee.cellNumber
                            }
                        </div>
                    )}
                </>
            )

        case "3": // License States
            return (
                <>
                    {data.join(" | ")}
                </>
            )   

        case "4": // Branch Location Type (reserved — future client use)
            return (
                <>
                    {data?._type}
                </>
            )

        case "5": // Processing Plan
            return (
                <>
                    {data?.option === 'Other'
                        ? `Other | ${data?.other || ''}`
                        : (data?.option || '')}
                </>
            )

        case "6": // Margin Management
            return (
                <>
                    Details of Margin and Branch Revenue Cap
                </>
            )

        case "7": // Branch Location Option
            return (
                <>
                    {data._option}
                </>
            )
        
        case "8": // Branch Location Details
            return (
                <>
                    <p><span className="font-medium">Branch Address: </span>{data.address}</p>
                    <p><span className="font-medium">Tenant: </span>{data.tenant}</p>
                    <p><span className="font-medium">Landlord: </span>{data.landlord}</p>
                    <p><span className="font-medium">Total Monthly Rent including Taxes & CAM: $</span>{data.amount}</p>
                </>
            )

        case "9": // Services & Utilities
            return (
                <>
                    <p><span className="font-medium">Utilities: </span>{data.utilities.data.map(item => item.name).join(", ")}</p>
                </>
            )

        case "10": // Micro Cut Shredder
            return (
                <>
                    <p><span className="font-medium">Has Micro Cut Shredder: </span>{data.shredder_option}</p>
                    {/* {data.shredder_option === 'Yes' &&  */}
                        {/* <> */}
                            {/* image preview  */}
                            {/* <img src={BACKEND_API_URL + data.shredder_image} alt="Micro Cut Shredder" className="mt-2 w-60 h-40" /> */}
                        {/* </>  */}
                    {/* } */}
                </>
            )

        case "11": // Locking Cabinet Details
            return (
                <>
                    <p><span className="font-medium">Has Locking File Cabinet: </span>{data._option}</p>
                    {/* {data._option === 'Yes' &&  */}
                        {/* <> */}
                            {/* image preview  */}
                            {/* <img src={BACKEND_API_URL + data._image} alt="Locking Cabinet" className="mt-2 w-60 h-40" /> */}
                        {/* </>  */}
                    {/* } */}
                </>
            )

        case "12": // Local IT Company Details
            return (
                <>
                    <p><span className="font-medium">Do you work with local IT company? : </span>{data._option}</p>
                    {data._option === 'Yes' && 
                        <>
                            <p><span className="font-medium">Company Name: </span>{data.company}</p>
                            <p><span className="font-medium">Contact Name: </span>{data.contactName}</p>
                            <p><span className="font-medium">Contact Phone Number: </span>{data.contactPhone}</p>
                            <p><span className="font-medium">Email: </span>{data.email}</p>
                            <p><span className="font-medium">Services Provided: </span>{data.servicesProvided}</p>
                        </> 
                    }
                </>
            )
            
        case "13": // Office Space Other Business Details
            return (
                <>
                    <span className="font-medium">Does your location have a private place to meet, exclusive to mortgage, behind a closed door? : </span>
                    <p> {data.office_space_detail.place_option}</p>
                </>
            )

        case "14": // Office Space Other Business Details
            return (
                <>
                    <p><span className="font-medium">Do you share office space with any other businesses? : </span>{data.office_space_detail._option}</p>
                    {data.office_space_detail._option === 'Yes' && 
                        <>
                            {data.related_businesses.map((business, index) => 
                                <div key={index}>
                                    {index+1 + ". " + business.name + ' | ' 
                                        + business.industry + ' | ' 
                                        + business.contactEmail + ' | ' 
                                        + business.contactNumber
                                    }
                                </div>
                            )}
                        </> 
                    }
                </>
            )
    
        case "15": // Mortgage Sign
            return (
                <>
                    <p><span className="font-medium">Do you have a Rize Mortgage Sign for your office? : </span>{data.sign_option}</p>
                    {/* {data.sign_option === 'Yes' && 
                        <> */}
                            {/* image preview  */}
                            {/* <img src={BACKEND_API_URL + data._image} alt="Rize Mortgage Sign" className="mt-2 w-60 h-40" />
                        </>
                    } */}
                    { data.sign_option !== 'Ordered' && <p><span className="font-medium">Do you need the Rize Logo for your sign provider? : </span>{data.logo_option}</p>}
                </>
            )

        case "16": // Compliance Signage
            return (
                <>
                    <p><span className="font-medium">Do you have an Equal Housing Lender/ECOA poster/sign in your office? : </span>{data.fairhousing_sign_option}</p>
                    {/* {data.fairhousing_sign_option === 'Yes' && 
                        <> */}
                            {/* image preview  */}
                            {/* <img src={BACKEND_API_URL + data.fairhousing_sign_image} alt="Fairhousing poster/sign" className="mt-2 w-60 h-40" />
                        </>
                    } */}
                    {/* <p><span className="font-medium">Do you have a Home Mortgage Disclosure Act (HMDA) poster/sign in your office? : </span>{data.hdma_sign_option}</p> */}
                    {/* {data.hdma_sign_option === 'Yes' && 
                        <> */}
                            {/* image preview  */}
                            {/* <img src={BACKEND_API_URL + data.hdma_sign_image} alt="HMDA poster/sign" className="mt-2 w-60 h-40" />
                        </>
                    } */}
                    <p><span className="font-medium">Do you have all applicable, current Labor Law Poster(s)? : </span>{data.labor_law_sign_option}</p>
                    {/* {data.labor_law_sign_option === 'Yes' && 
                        <> */}
                            {/* image preview  */}
                            {/* <img src={BACKEND_API_URL + data.labor_law_sign_image} alt="Labor Law Poster(s)" className="mt-2 w-60 h-40" />
                        </>
                    } */}
                </>
            )

        case "17": // Occupational License
            return (
                <>
                    <p><span className="font-medium">Does your Town, City or County require an occupational or any other license type to conduct business? : </span>{data._option}</p>
                    {data._option === 'Yes' && 
                        <ul>
                            {data.agencyWebsite.map((item, index) => (
                                <li key={index}>
                                    <span className="font-medium text-gray-600">Description: </span>{item.description} | <span className="font-medium text-gray-600">Link: </span>{item.link}
                                </li>
                            ))}
                        </ul>
                        // <p><span className="font-medium">Agency Website: </span>{data.agencyWebsite}</p>
                    }
                </>
            )

        case "18": // Marketing Details
            return (
                <div>
                    <div className="mb-4">
                        <p><span className="font-medium">Team / Branch Name : </span>{data?.companyBranchName || data?.companyTeamName}</p>
                    </div>

                    <div className="my-4">
                        <p><span className="font-medium">Will this opportunity be a formal DBA? : </span>{data?.isDBA}</p>
                    </div>

                    <div className="my-4">
                        <p><span className="font-medium">Do you have an existing website that you use for your branch? : </span>{data?.isWebsite}</p>
                        {data?.isWebsite === 'Yes' && <div className="m-2">
                                <li><span className="font-medium">Branch Website : </span>{data?.branchWebsite}</li>
                        </div>}
                    </div>


                    <div className="my-4">
                        <p><span className="font-medium">Do you have any existing social media profiles for your branch/team? : </span>{data?.isSocialMediaProfiles}</p>
                        {data?.isSocialMediaProfiles === 'Yes' && <div className="m-2">
                                <li><span className="font-medium">LinkedIn : </span>{data?.branchLinkedIn}</li>
                                <li><span className="font-medium">Twitter(X) Profile : </span>{data?.branchTwitterXProfile}</li>
                                <li><span className="font-medium">Facebook Profile : </span>{data?.branchFacebookProfile}</li>
                                <li><span className="font-medium">Instagram Profile : </span>{data?.branchInstagramProfile}</li>
                                <li><span className="font-medium">Zillow Profile : </span>{data?.branchZillowProfile}</li>
                                <li><span className="font-medium">Google My Business : </span>{data?.branchGoogleMyBusiness}</li>
                        </div>}
                    </div>

                    <div className="my-4">
                        <p><span className="font-medium">Do you have any branch or team photos you would like our marketing department to use for your team? : </span>{data?.isTeamPhoto}</p>
                        {data?.isTeamPhoto === 'Yes' && 
                            <div className="m-2">
                               {toFileList(data?.teamPhotos).map((image, i) => 
                                       <li className="ml-6" key={i}>
                                           {getFileName(image)}
                                       </li>
                               )}
                            </div>
                        }
                    </div>

                    {toFileList(data?.branchPhotos).length > 0 && (
                        <div className="my-4">
                            <p><span className="font-medium"> Branch Photo (this is a separate pic of the actual physical loacation for google my business)</span></p>
                            <div className="m-2">
                                {toFileList(data?.branchPhotos).map((image, i) => 
                                        <li className="ml-6" key={i}>
                                            {getFileName(image)}
                                        </li>
                                )}
                            </div>
                        </div>
                    )}

                    {toFileList(data?.branchImages).length > 0 && (
                        <div className="my-4">
                            <p><span className="font-medium"> Branch Images (Optional)</span></p>
                            <div className="m-2">
                                {toFileList(data?.branchImages).map((image, i) => 
                                        <li className="ml-6" key={i}>
                                            {getFileName(image)}
                                        </li>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            )
        default:
            return ''

    }
}